export default __webpack_public_path__ + "static/media/093-compress-1.cb82fe92.png";